import React, { useEffect, useState } from 'react';
import { UniversalLink } from '@plone/volto/components';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import './styles.css';

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);  
  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 
                     'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  if (day == 'NaN') return '';

  return `${day} ${month} ${year}`;
};

const RSSDataView = (props) => {
  const { data } = props;
  const { 
    title, 
    cardStyle = 'simple', 
    maxResults = 5, 
    feedUrl, 
    buttonText, 
    buttonLink,
    showPublishDate = true, // Valore predefinito true se non specificato
    showFourthColumn = false
  } = data;
  const [feedItems, setFeedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cleanImageUrl = (url) => {
    if (!url) return url;
    // Decodifica gli URL codificati e sostituisce le entità HTML
    let cleanedUrl = url.replace(/&amp;/g, '&');
    cleanedUrl = decodeURIComponent(cleanedUrl);
    return cleanedUrl;
  };

  useEffect(() => {
    if (!feedUrl) return;

    setLoading(true);
    setError(null);

    const proxyUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(feedUrl)}`;
    
    fetch(proxyUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Errore nel caricamento del feed RSS');
        return response.json();
      })
      .then((data) => {
        //console.log('Raw feed data:', data); // Debug completo
        const items = data.items || [];
        
        // Mappa gli elementi per estrarre correttamente le immagini
        const processedItems = items.map(item => {
          // Estrai l'URL dell'immagine dall'enclosure o dal thumbnail
          let imageUrl = '';
          
          if (item.link) {
            imageUrl = item.link + '/@@images/preview_image/preview';
          } else if (item.thumbnail) {
            imageUrl = item.thumbnail;
          }
          
          // Pulisci l'URL dell'immagine
          imageUrl = cleanImageUrl(imageUrl);

          return {
            
            ...item,
            imageUrl: imageUrl,
            cleanedImageUrl: imageUrl // Mantieni entrambi per compatibilità
          };
          
        });
        
        setFeedItems(processedItems.slice(0, maxResults));
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        console.error('Error fetching RSS feed:', err);
      });
  }, [feedUrl, maxResults]);

  const minWidth = showFourthColumn ? '220px' : '280px';

  return (
    <div className='block listing image_card'><div className={`full-width-background-wrapper`}>
      <div className="image-card-listing-container">
        {title && <h2>{title}</h2>}
        {loading && <p>Caricamento in corso...</p>}
        {error && <p>Errore: {error}</p>}
        {!loading && !error && feedItems.length === 0 && <p>Nessun elemento trovato nel feed.</p>}
        {!loading && !error && feedItems.length > 0 && (
          <>
            <div className="image-card-listing" style={{
              gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))`
            }}>
              {feedItems.map((item, index) => (
                
                <div className="image-card" key={item['@id'] || index}>
                 
                  {cardStyle === 'image' && item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="rss-card-image"
                      onError={(e) => {
                        e.target.style.display = 'none'; // Nascondi l'immagine se non può essere caricata
                      }}
                    />
                  )}
                  <div className="card-content">
                   
                    {showPublishDate && item.pubDate && (
                      <div className="date-with-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-newspaper" viewBox="0 0 16 16">
                          <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z" />
                          <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z" />
                        </svg>
                        <span className="publish-date">
                          {formatDate(item.pubDate)}
                        </span>
                      </div>
                    )}
                    <h3 className="card-title">
                      <UniversalLink href={item.link}>{item.title}</UniversalLink>
                    </h3>


                    {item.description && (
                      <p className="card-description">{item.description}</p>
                    )}
                    
                  </div>

                </div>
              ))}
            </div>
            {buttonText && buttonLink && (
              <div className="rss-button-container">
                <UniversalLink href={buttonLink} className="rss-button">
                  {buttonText}
                </UniversalLink>
              </div>
            )}
          </>
        )}
      </div>
    </div></div>
  );
};

export default RSSDataView;